export default __webpack_public_path__ + "static/media/hackathonLogo.1eac098a.png";